export const pageImages = require.context('../assets/images', true); //webpack
